import { render, staticRenderFns } from "./ProductNotes.vue?vue&type=template&id=74890d41&scoped=true&lang=pug&"
import script from "./ProductNotes.vue?vue&type=script&lang=ts&"
export * from "./ProductNotes.vue?vue&type=script&lang=ts&"
import style0 from "./ProductNotes.vue?vue&type=style&index=0&id=74890d41&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74890d41",
  null
  
)

export default component.exports